import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import {
  Button, ButtonToolbar, Modal, Table, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/lib/Async';
import parse from 'html-react-parser';

import CreatableSelect from 'react-select/lib/Creatable';
import SelectService from '../../../services/SelectService';
import global from '../../../global';

class AddInventoryModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    modal: PropTypes.bool,
    locationID: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
    locationType: PropTypes.string,
  };

  static defaultProps = {
    title: 'User',
    color: 'primary',
    modal: false,
    locationID: '',
    postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
    locationType: 0,
  };

  constructor() {
    super();
    this.state = {
      modal: false,
      rooms: [],
      grandTotal: 0,
      prodIndexes: [{
        index: 0,
        quality: 0,
        unitCost: 0,
        total: 0,
      }],
    };

    this.userdata = JSON.parse(localStorage.getItem('userData'));
    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
    this.onChangeQuantityAndCost = this.onChangeQuantityAndCost.bind(this);
  }

  componentDidMount() {
    this.getProducts();
    this.getRooms();
    // console.log(this.userdata.type);
  }

  componentWillReceiveProps(nextProps) {
    this.userdata = JSON.parse(localStorage.getItem('userData'));

    if (!nextProps.errorMsg && nextProps.modal) {
      this.setState({
        prodIndexes: [{
          index: 0,
          total: 0,
        }],
        grandTotal: 0,
      });
      this.getProducts();
      this.getRooms();
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  handleInputChange = (e, fieldType = 'product') => {
    if (fieldType === 'room') {
      this.getRooms(e);
    } else {
      this.getProducts(e);
    }
  }

  getProducts = async (newValue) => {
    const formData = { searchFor: newValue };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listProductOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.product_id,
              label: opt.product_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }
    this.isLoading = false;
    this.setState({ products: options });
  }

  getSuppliers = async (newValue) => {
    const formData = { searchFor: newValue };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listSupplierOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.supplier_id,
              label: opt.supplier_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }

    this.isLoading = false;
    return options;
  }

  getRooms = async (newValue) => {
    const { locationID } = this.props;
    const formData = { searchFor: newValue, locationid: locationID };
    try {
      const response = await SelectService.listRoomOptions(formData);
      this.isLoading = true;
      if (this.isLoading) {
        this.setState({ rooms: response });
      }
    } catch (err) {
      console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  addProduct = (e) => {
    e.preventDefault();
    const { prodIndexes } = this.state;
    const lastItem = prodIndexes.slice(-1)[0].index;
    prodIndexes.push({
      index: parseInt(lastItem + 1, 10),
      total: 0,
    });
    this.setState({ ...prodIndexes, prodIndexes });
  }

  onChangeQuantityAndCost = (e, index = '') => {
    const { prodIndexes } = this.state;
    const ret = global.numbersonly(e);
    let quantity = 0;
    let unitcost = 0;
    let total = 0;
    let gTotal = 0;

    // replace non-numeric values to empty
    if (!ret) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
    }

    // calculate total
    if (index !== '') {
      const docQ = document.getElementsByName(`quantity[${index}]`)[0] !== undefined ? document.getElementsByName(`quantity[${index}]`)[0].value : 0;
      const docUc = document.getElementsByName(`unitCost[${index}]`)[0] !== undefined ? document.getElementsByName(`unitCost[${index}]`)[0].value : 0;
      quantity = docQ !== '' ? docQ : 0;
      quantity = parseFloat(quantity, 10);
      unitcost = docUc !== '' ? docUc : 0;
      unitcost = parseFloat(unitcost, 10);
      total = parseFloat(quantity * unitcost, 10).toFixed(2);
      const objIdx = prodIndexes.findIndex(x => x.index === index);
      prodIndexes[objIdx].total = global.numberFormat(total);

      if (prodIndexes) {
        prodIndexes.map((item) => {
          gTotal = parseFloat(gTotal, 10) + parseFloat(item.total, 10);
          return gTotal.toFixed(2);
        });
      }
    }

    this.setState({ prodIndexes, grandTotal: gTotal });
  }

  removeProdItem = (e, index) => {
    e.preventDefault();
    let { prodIndexes } = this.state;
    prodIndexes = prodIndexes.filter(resp => parseInt(resp.index, 10) !== parseInt(index, 10));
    this.setState({ prodIndexes });
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      color, modal, toggle, title, handleChange, handleSubmit, errorMsg, postValue, locationType,
    } = this.props;
    const {
      rooms, products, prodIndexes, grandTotal,
    } = this.state;
    const selectedDate = new Date(postValue.deliveryDate);
    const selectediDate = new Date(postValue.inventoryDate);

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header modal-vx"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title}</h4>
          </div>
          <form id="insertInventory_form" onSubmit={handleSubmit}>
            <div className="modal__body">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <div className="alert__content">
                      <div>{ parse(errorMsg) }</div>
                    </div>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Inventory Date:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <div className="date-picker">
                      <DatePicker
                        name="inventoryDate"
                        selected={postValue.inventoryDate ? selectediDate : new Date()}
                        onChange={e => handleChange(e, 'idate')}
                      />
                    </div>
                    <div className="form__form-group-icon">
                      <i className="fa fa-calendar-alt" />
                    </div>
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Reference No.:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="referenceNumber" placeholder="Reference No." />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Batch Code:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="batchCode" placeholder="Product batch code..." />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Supplier:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                  <AsyncSelect
                    name="supplier"
                    cacheOptions
                    loadOptions={this.getSuppliers}
                    defaultOptions
                    className="react-select"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                  />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Delivery Date:<b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <div className="date-picker">
                      <DatePicker
                        name="deliveryDate"
                        selected={postValue.deliveryDate ? selectedDate : new Date()}
                        onChange={e => handleChange(e, 'ddate')}
                      />
                    </div>
                    <div className="form__form-group-icon">
                      <i className="fa fa-calendar-alt" />
                    </div>
                  </div>
                </div>

                <Table className="no_hover transaction_board" id="product_table">
                  <thead>
                    <tr>
                      <th>Product <b className="text-danger">*</b></th>
                      <th>Quantity <span className="text-danger"><i>(Kilos)</i> *</span></th>
                      {
                        this.userdata.type && ((['1', '6'].indexOf(this.userdata.type) > -1) === true) && (
                          <>
                            <th>Unit Cost <b className="text-danger">*</b></th>
                            <th>Total <b className="text-danger">*</b></th>
                          </>
                        )
                      }
                      {
                        locationType && locationType === '1' && (
                          <>
                          <th>Room</th>
                          </>
                        )
                      }
                      <th><></></th>
                    </tr>
                  </thead>
                  <tbody>
                    {prodIndexes.length > 0 && prodIndexes.map((item, k) => {
                      const trkey = `tr_row${k + 1}`;
                      const itemTotal = item.total === 0 ? 0 : global.parseToNumber(item.total, 'float');

                      return (
                        <tr key={trkey}>
                          <td data-tx="Product" className="v-top">
                            <CreatableSelect
                              name={`product[${item.index}]`}
                              options={products}
                              isClearable
                              className="react-select"
                              classNamePrefix="react-select"
                              placeholder="Select product"
                              onInputChange={e => this.handleInputChange(e)}
                            />
                          </td>
                          <td data-tx="Quantity">
                            <input type="text" name={`quantity[${item.index}]`} placeholder="Quantity" onChange={e => this.onChangeQuantityAndCost(e, item.index)} />
                          </td>
                          {
                            this.userdata.type && ((['1', '6'].indexOf(this.userdata.type) > -1) === true) && (
                              <>
                                <td data-tx="Unit Cost">
                                  <input type="text" name={`unitCost[${item.index}]`} placeholder="Unit Cost" onChange={e => this.onChangeQuantityAndCost(e, item.index)} />
                                </td>
                                <td className="td_total" data-tx="Total"><span className="m-r-3">&#x20B1;</span> {global.numberFormat(itemTotal)}</td>
                              </>
                            )
                          }
                          {
                            this.userdata.type && ((['2', '3'].indexOf(this.userdata.type) > -1) === true) && (
                              <>
                                <td data-tx="Unit Cost" style={{ display: 'none' }}>
                                  <input type="hidden" name={`unitCost[${item.index}]`} placeholder="Unit Cost" onChange={e => this.onChangeQuantityAndCost(e, item.index)} value="0" />
                                </td>
                              </>
                            )
                          }
                          {
                            locationType && locationType === '1' && (
                              <>
                              <td data-tx="Room" className="v-top">
                                <CreatableSelect
                                  name={`room[${item.index}]`}
                                  options={rooms}
                                  isClearable
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  placeholder="Enter room"
                                />
                              </td>
                              </>
                            )
                          }
                          <td className="le-td">
                            {
                              item.index !== 0 && (
                                <Button type="button" className="rounded btn-xs le-btn" onClick={e => this.removeProdItem(e, item.index)}><i className="fa fa-times" /> <span>Remove Product</span></Button>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })}
                    <tr className="d">
                      <td colSpan="5">
                        <div id="add_product_btn" className="text-right col-md-12 p-0">
                          <Button onClick={this.addProduct} color="success" className="rounded m-b-10" size="sm"><i className="fa fa-plus-circle" />&nbsp; Add Product</Button>
                        </div>
                      </td>
                    </tr>
                    {
                      this.userdata.type && ((['1', '6'].indexOf(this.userdata.type) > -1) === true) && (
                        <>
                          <tr>
                            <td className="bold" width="25%">Grand Total:</td>
                            <td className="text-right text-primary" colSpan="2">&nbsp;</td>
                            <td className="text-primary n" colSpan="2">
                              &#x20B1; {global.numberFormat(grandTotal)}
                            </td>
                          </tr>
                        </>
                      )
                    }
                  </tbody>
                </Table>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color={color}>Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'warehouse_insertInventory', // a unique identifier for this form
})(withTranslation('common')(AddInventoryModal));
